import React, { useState, useEffect } from "react";
import { Nav, Navbar, NavDropdown, Button } from "react-bootstrap";
import "./Navbar.css";
import { Link } from "react-router-dom";
import AuthService from "../../Login/Services/auth.service";
import logo from "../../image/logowhite.png";

import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import LogoutIcon from "@material-ui/icons/PowerSettingsNew";
import ServiceAdmin from "../../HomePage/PageHomeAdmin/Services/ServiceAdmin";
const Header = (props) => {
  const { Message } = props;
  const [currentUser, setCurrentUser] = useState(undefined);
  //super admin
  const [showSuperAdmin, setShowSuperAdmin] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);
  const [showMember, setShowMember] = useState(false);
  const [showUser, setShowUser] = useState(false);
  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      setCurrentUser(user);
      setShowMember(user.role.includes("MEMBRE"));
      setShowAdmin(user.role.includes("ADMIN"));
      setShowUser(user.role.includes("USER"));
      setShowSuperAdmin(user.role.includes("SUPER_ADMIN"));
      if (user.role === "ADMIN") {
        GetdataCabinet(user.id);
      }
    }
  }, []);

  //get dataCabinet
  const GetdataCabinet = (id) => {
    ServiceAdmin.getprofile(id).then((res) => {
      console.log("api get ", res.data.laboratory);
      if (res.data) {
        // setInfoMedecin(res.data);
        sessionStorage.setItem(
          "dataCabinet",
          JSON.stringify(res.data.laboratory ? res.data.laboratory : {})
        );
      }
    });
  };

  const [checkMessage, setMheckMessage] = useState(true);
  console.log(Message, checkMessage);
  useEffect(() => {
    if (Message === "active") {
      setMheckMessage(false);
    }
  });
  const [show, setShow] = useState(false);
  const HandleShow = () => setShow(true);
  const Toggle = () => {
    setShow(false);
  };
  const Logout = () => {
    AuthService.logout();
  };
  // console.log("this is a role ", AuthService.getCurrentUser().role);

  return (
    <>
      <Navbar collapseOnSelect expand="lg" variant="dark" className="Navbar">
        <div className="container">
          <Navbar.Brand href="">
            <img src={logo} width="96px" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          {/* //////////////////////////////////////// ADMIN //////////////////////////////////////// */}
          {showAdmin && AuthService.getCurrentUser().role === "ADMIN" && (
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="mr-auto">
                <Button
                  disabled={showUser}
                  style={{ background: "transparent", border: "none" }}
                >
                  <Link
                    to={showUser ? "/home" : "/formcarander"}
                    className="Navbar-Link"
                  >
                    Planifier-calendrier
                  </Link>
                </Button>
                <Button
                  disabled={showUser}
                  style={{ background: "transparent", border: "none" }}
                >
                  <Link
                    to={showUser ? "/home" : "/rendezvous"}
                    className="Navbar-Link"
                  >
                    Rendez-vous pris
                  </Link>
                </Button>
                <Button
                  disabled={showUser}
                  style={{ background: "transparent", border: "none" }}
                >
                  <Link
                    to={showUser ? "/home" : "/programe"}
                    className="Navbar-Link"
                  >
                    Programmes
                  </Link>
                </Button>
                <Button
                  disabled={showUser}
                  style={{ background: "transparent", border: "none" }}
                >
                  <Link
                    to={showUser ? "/home" : "/patient"}
                    className="Navbar-Link"
                  >
                    Patients
                  </Link>
                </Button>
              </Nav>
            </Navbar.Collapse>
          )}
          {/* //////////////////////////////////////// USER////////////////////////////////////////// */}
          {showUser && AuthService.getCurrentUser().role === "USER" && (
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="mr-auto">
                <Button
                  disabled={showUser}
                  style={{ background: "transparent", border: "none" }}
                >
                  <Link className="Navbar-Link">Planifier-calendrier</Link>
                </Button>
                <Button
                  disabled={showUser}
                  style={{ background: "transparent", border: "none" }}
                >
                  <Link className="Navbar-Link">Rendez-vous pris</Link>
                </Button>
                <Button
                  disabled={showUser}
                  style={{ background: "transparent", border: "none" }}
                >
                  <Link className="Navbar-Link">Programmes</Link>
                </Button>
                <Button
                  disabled={showUser}
                  style={{ background: "transparent", border: "none" }}
                >
                  <Link className="Navbar-Link">Patients</Link>
                </Button>
              </Nav>
            </Navbar.Collapse>
          )}
          {/* //////////////////////////////////////// SUPERADMIN/////////////////////////////////////// */}
          {showSuperAdmin &&
            AuthService.getCurrentUser().role === "SUPER_ADMIN" && (
              <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="mr-auto">
                  <Link to="/members" className="Navbar-Link">
                    Membres
                  </Link>
                </Nav>
              </Navbar.Collapse>
            )}
          {currentUser ? (
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="ml-auto">
                {showMember && (
                  <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="ml-auto">
                      <Link
                        to="/"
                        className="Navbar-Link"
                        onClick={() =>
                          sessionStorage.getItem("Type") &&
                          sessionStorage.removeItem("Type")
                        }
                      >
                        Prenez Rendez-Vous
                      </Link>
                      <Link to="/mesrdv" className="Navbar-Link">
                        Mes Rendez-Vous
                      </Link>
                    </Nav>
                  </Navbar.Collapse>
                )}
                {(showMember ||
                  AuthService.getCurrentUser().role === "SUPER_ADMIN") && (
                  <Link className="Navbar-Link">
                    <LogoutIcon
                      style={{ fontSize: "xx-large", color: "red" }}
                      className="LogoutIcon"
                      onClick={() => Logout()}
                    />
                  </Link>
                )}
                {/* ///////////////////////////////////////////NavDropdown ADMIN  ///////////////////: */}
                {showAdmin && AuthService.getCurrentUser().role === "ADMIN" && (
                  <>
                    <NavDropdown
                      title={
                        <AccountCircleIcon
                          style={{
                            color: "#f1f1f1",
                            fontSize: "xxx-large",
                          }}
                        />
                      }
                      id="basic-nav-dropdown"
                    >
                      <NavDropdown.Item className="Navbar-Link">
                        <Button
                          style={{ background: "transparent", border: "none" }}
                        >
                          <Link
                            style={{
                              textDecoration: "none",
                              width: "100%",
                            }}
                            to="/profile"
                            onClick={() => {
                              sessionStorage.setItem(
                                "healthId",
                                JSON.stringify({ id: currentUser.id })
                              );
                            }}
                          >
                            <img
                              style={{
                                width: "40px",
                                padding: "4px 5px",
                              }}
                              src="https://img.icons8.com/flat_round/64/000000/settings--v1.png"
                            />
                            <span
                              style={{
                                color: "#276955",
                                marginLeft: "10%",
                                textTransform: "capitalize",
                              }}
                            >
                              Profil
                            </span>
                          </Link>
                        </Button>
                      </NavDropdown.Item>
                      <NavDropdown.Item className="Navbar-Link">
                        <Button
                          style={{ background: "transparent", border: "none" }}
                        >
                          <Link
                            style={{
                              textDecoration: "none",
                              width: "100%",
                            }}
                            to="/calendar"
                            onClick={() => {
                              sessionStorage.setItem(
                                "healthId",
                                JSON.stringify({ id: currentUser.id })
                              );
                            }}
                          >
                            <img
                              style={{
                                width: "40px",
                                padding: "4px 5px",
                              }}
                              src="https://img.icons8.com/fluent/48/000000/calendar.png"
                            />
                            <span
                              style={{
                                color: "#276955",
                                marginLeft: "10%",
                                textTransform: "capitalize",
                              }}
                            >
                              Calendrier
                            </span>
                          </Link>
                        </Button>
                      </NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item className="Navbar-Link">
                        <Link
                          style={{
                            textDecoration: "none",
                            width: "100%",
                          }}
                          onClick={() => Logout()}
                        >
                          <LogoutIcon
                            style={{ fontSize: "xx-large", color: "red" }}
                            className="LogoutIcon"
                          />
                          <span
                            style={{
                              color: "#276955",
                              marginLeft: "10%",
                              textTransform: "capitalize",
                            }}
                          >
                            Déconnecter
                          </span>
                        </Link>
                      </NavDropdown.Item>
                    </NavDropdown>
                  </>
                )}
                {/* ///////////////////////////////////////////NavDropdown USER  ///////////////////: */}

                {showUser && AuthService.getCurrentUser().role === "USER" && (
                  <>
                    <NavDropdown
                      title={
                        <AccountCircleIcon
                          style={{
                            color: "#f1f1f1",
                            fontSize: "xxx-large",
                          }}
                        />
                      }
                      id="basic-nav-dropdown"
                    >
                      <NavDropdown.Item className="Navbar-Link">
                        <Button
                          disabled={checkMessage}
                          style={{ background: "transparent", border: "none" }}
                        >
                          <Link
                            style={{
                              textDecoration: "none",
                              width: "100%",
                            }}
                            to={!checkMessage && "/profile"}
                            onClick={() => {
                              sessionStorage.setItem(
                                "healthId",
                                JSON.stringify({ id: currentUser.id })
                              );
                            }}
                          >
                            <img
                              style={{
                                width: "40px",
                                padding: "4px 5px",
                              }}
                              src="https://img.icons8.com/flat_round/64/000000/settings--v1.png"
                            />
                            <span
                              style={{
                                color: "#276955",
                                marginLeft: "10%",
                                textTransform: "capitalize",
                              }}
                            >
                              Profil
                            </span>
                          </Link>
                        </Button>
                      </NavDropdown.Item>

                      <NavDropdown.Divider />
                      <NavDropdown.Item className="Navbar-Link">
                        <Link
                          style={{
                            textDecoration: "none",
                            width: "100%",
                          }}
                          onClick={() => Logout()}
                        >
                          <LogoutIcon
                            style={{ fontSize: "xx-large", color: "red" }}
                            className="LogoutIcon"
                          />
                          <span
                            style={{
                              color: "#276955",
                              marginLeft: "10%",
                              textTransform: "capitalize",
                            }}
                          >
                            Déconnecter
                          </span>
                        </Link>
                      </NavDropdown.Item>
                    </NavDropdown>
                  </>
                )}
                <span className="Navbar-Link2">
                  {`${currentUser.firstName} ${currentUser.lastName}`}
                </span>
              </Nav>
            </Navbar.Collapse>
          ) : (
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="ml-auto">
                {/* <Nav.Link  className="Navbar-Link" onClick={() => HandleShow()}>Login</Nav.Link> */}
                <Link to="/" className="Navbar-Link">
                  Je suis un partient
                </Link>
              </Nav>
            </Navbar.Collapse>
          )}
        </div>
      </Navbar>
    </>
  );
};

export default Header;
